import ReactTooltip from "react-tooltip";
const poste = localStorage.getItem("poste");
const postemaster = localStorage.getItem("posteMaster");
const tabcollegue = JSON.parse(localStorage.getItem("tabcollegue") ?? null);

const displayNumber = (collegue) => {
  if (
    (collegue.src == poste && tabcollegue !== null) ||
    collegue.src == postemaster
  ) {
    return (
      <div className="text-xs leading-5 text-gray-500">{collegue.dst}</div>
    );
  } else {
    return (
      <div className="text-xs leading-5 text-gray-500">{collegue.src}</div>
    );
  }
};
const displayIcon = (disposition, src, t, extra) => {
  if (src === poste || src === postemaster) {
    if (disposition === "ANSWERED") {
      return (
        <div data-tip data-for="émis1">
          <ReactTooltip id="émis1" place="bottom" effect="solid">
            <div> {t("appelemis")}</div>
          </ReactTooltip>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-blue-500 dark:text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
            />
          </svg>
        </div>
      );
    } else if (disposition === "NO ANSWER") {
      return (
        <div data-tip data-for="émis2">
          <ReactTooltip id="émis2" place="bottom" effect="solid">
            <div>
              {" "}
              {t("appelemis")} , {t("ringing")} {extra.ringingsec} sec
            </div>
          </ReactTooltip>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-gray-400 dark:text-blue"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
            />
          </svg>
        </div>
      );
    } else {
      return (
        <div data-tip data-for="échoué">
          <ReactTooltip id="échoué" place="bottom" effect="solid">
            <div> {t("failedcall")}</div>
          </ReactTooltip>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-red-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
            />
          </svg>
        </div>
      );
    }
  }

  if (src !== poste || src !== postemaster) {
    if (disposition === "ANSWERED") {
      return (
        <div data-tip data-for="recu">
          <ReactTooltip id="recu" place="bottom" effect="solid">
            {t("appelrecu")}
          </ReactTooltip>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
            />
          </svg>
        </div>
      );
    } else {
      return (
        <div data-tip data-for="manqué">
          <ReactTooltip id="manqué" place="bottom" effect="solid">
            {t("appel.manque")}
          </ReactTooltip>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-red-700"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
            />
          </svg>
        </div>
      );
    }
  }
};
const displayNameGeneric = (valueToCompare, dataArray, matcher) => {
  if (dataArray == null) return null;

  for (let i = 0; i < dataArray.length; i++) {
    if (matcher(dataArray[i], valueToCompare)) {
      return dataArray[i];
    }
  }
  return null;
};
const formatDate = (dateString, t) => {
  if (!dateString || dateString === "0000-00-00 00:00:00") {
    return <div className="w-full flex items-center justify-center">-</div>;
  }
  const inputDate = new Date(dateString);
  const today = new Date();
  const yesterday = new Date();

  today.setHours(0, 0, 0, 0);
  yesterday.setDate(today.getDate() - 1);
  yesterday.setHours(0, 0, 0, 0);

  const inputDateZero = new Date(inputDate);
  inputDateZero.setHours(0, 0, 0, 0);

  const timePart = dateString.split(" ")[1] || "";

  if (inputDateZero.getTime() === today.getTime()) {
    return `${t("aujourdhui")} ${t("at")} ${timePart}`;
  }

  if (inputDateZero.getTime() === yesterday.getTime()) {
    return `${t("hier")} ${t("at")} ${timePart}`;
  }

  const [datePart] = dateString.split(" ");
  const [year, month, day] = datePart.split("-");
  const formattedDate = `${day}/${month}/${year}`;

  return `${t("le")} ${formattedDate} ${t("at")} ${timePart}`;
};
function formatSecondsToHMS(seconds) {
  const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
  const s = String(seconds % 60).padStart(2, "0");

  return `${h}:${m}:${s}`;
}

export {
  displayIcon,
  displayNumber,
  displayNameGeneric,
  formatDate,
  formatSecondsToHMS,
};
